exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\ninput[type='time'] {\n  cursor: text;\n}\ninput[type='time']::-webkit-calendar-picker-indicator {\n  background: none;\n  display: none;\n}\n", ""]);

